// Hospital Data
const HOSPITALLISTDATA='HOSPITALLISTDATA';

const HOSPITAL_PHARMACY_REQUEST = 'HOSPITAL_PHARMACY_REQUEST';
const HOSPITAL_PHARMACY_SUCCESS = 'HOSPITAL_PHARMACY_SUCCESS';
const HOSPITAL_PHARMACY_FAILURE = 'HOSPITAL_PHARMACY_FAILURE';

const HOSPITAL_FACILITY_REQUEST = 'HOSPITAL_FACILITY_REQUEST';
const HOSPITAL_FACILITY_SUCCESS = 'HOSPITAL_FACILITY_SUCCESS';
const HOSPITAL_FACILITY_FAILURE = 'HOSPITAL_FACILITY_FAILURE'; 

const REGION_REQUEST_LIST = 'REGION_REQUEST_LIST';
const REGION_SUCCESS_LIST = 'REGION_SUCCESS_LIST';
const REGION_FAILURE_LIST = 'REGION_FAILURE_LIST';


const CREATE_HOSPITAL_FACILITY_REQUEST = 'CREATE_HOSPITAL_FACILITY_REQUEST';
const CREATE_HOSPITAL_FACILITY_SUCCESS = 'CREATE_HOSPITAL_FACILITY_SUCCESS';
const CREATE_HOSPITAL_FACILITY_FAILURE = 'CREATE_HOSPITAL_FACILITY_FAILURE'; 

const HOSPITAL_PHARMACY_GET_REQUEST = 'HOSPITAL_PHARMACY_GET_REQUEST';
const HOSPITAL_PHARMACY_GET_SUCCESS  = 'HOSPITAL_PHARMACY_GET_SUCCESS';
const HOSPITAL_PHARMACY_GET_FAILURE = 'HOSPITAL_PHARMACY_GET_FAILURE';

// Pharmacy Getby Id
const PHARMACY_REQUEST_GETBYID = 'PHARMACY_REQUEST_GETBYID';
const PHARMACY_SUCCESS_GETBYID = 'PHARMACY_SUCCESS_GETBYID';
const PHARMACY_FAILURE_GETBYID = 'PHARMACY_FAILURE_GETBYID';

// Pharmacy Delete
const PHARMACY_REQUEST_DELETE = 'PHARMACY_REQUEST_DELETE';
const PHARMACY_SUCCESS_DELETE = 'PHARMACY_SUCCESS_DELETE';
const PHARMACY_FAILURE_DELETE = 'PHARMACY_FAILURE_DELETE';

//Update
const PHARMACY_REQUEST_UPDATE = 'PHARMACY_REQUEST_UPDATE';
const PHARMACY_SUCCESS_UPDATE = 'PHARMACY_SUCCESS_UPDATE';
const PHARMACY_FAILURE_UPDATE = 'PHARMACY_FAILURE_UPDATE';

// Pharmacy Create
const PHARMACY_REQUEST_CREATE = 'PHARMACY_REQUEST_CREATE';
const PHARMACY_SUCCESS_CREATE = 'PHARMACY_SUCCESS_CREATE';
const PHARMACY_FAILURE_CREATE = 'PHARMACY_FAILURE_CREATE';

//Asl Dropdown
const ASL_GET_REQUEST = 'ASL_GET_REQUEST';
const ASL_GET_SUCCESS = 'ASL_GET_SUCCESS';
const ASL_GET_FAILURE = 'ASL_GET_FAILURE';
const ASL_GET_CHECK="ASL_GET_CHECK";
const ASL_GET_CHECKSUCCESS="ASL_GET_CHECKSUCCESS";
const ASL_GET_CHECkFAILURE="ASL_GET_CHECkFAILURE";

const REGION_ASL_REQUEST_LIST="REGION_ASL_REQUEST_LIST";
const REGION_ASL_SUCCESS_LIST="REGION_ASL_SUCCESS_LIST";
const REGION_ASL_FAILURE_LIST="REGION_ASL_FAILURE_LIST";

export {
    HOSPITALLISTDATA,
    HOSPITAL_PHARMACY_REQUEST,
    HOSPITAL_PHARMACY_SUCCESS,
    HOSPITAL_PHARMACY_FAILURE,
    HOSPITAL_FACILITY_FAILURE,
    HOSPITAL_FACILITY_SUCCESS,
    HOSPITAL_FACILITY_REQUEST,
    REGION_REQUEST_LIST,
    REGION_SUCCESS_LIST,
    REGION_FAILURE_LIST,
    HOSPITAL_PHARMACY_GET_SUCCESS,
    HOSPITAL_PHARMACY_GET_FAILURE,
    HOSPITAL_PHARMACY_GET_REQUEST,
    CREATE_HOSPITAL_FACILITY_REQUEST,
    CREATE_HOSPITAL_FACILITY_SUCCESS,
    CREATE_HOSPITAL_FACILITY_FAILURE,
    PHARMACY_REQUEST_GETBYID,
    PHARMACY_SUCCESS_GETBYID,
    PHARMACY_FAILURE_GETBYID,
    PHARMACY_REQUEST_DELETE,
    PHARMACY_SUCCESS_DELETE,
    PHARMACY_FAILURE_DELETE,
    PHARMACY_REQUEST_UPDATE,
    PHARMACY_SUCCESS_UPDATE,
    PHARMACY_FAILURE_UPDATE,
    PHARMACY_FAILURE_CREATE,
    PHARMACY_SUCCESS_CREATE,
    PHARMACY_REQUEST_CREATE,
    ASL_GET_FAILURE,
    ASL_GET_SUCCESS,
    ASL_GET_REQUEST,
    ASL_GET_CHECK,
    ASL_GET_CHECKSUCCESS,
    ASL_GET_CHECkFAILURE,
    REGION_ASL_REQUEST_LIST,
    REGION_ASL_SUCCESS_LIST,
    REGION_ASL_FAILURE_LIST,
};
